import React, { useState } from "react";
import useFetch from "../hooks/useFetch";
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";


import {Col, Container, Row} from "react-bootstrap";

/*
const breakpoints = [1080, 640, 384, 256, 128, 96, 64, 48];

function generateSrcSet({ url, width, height }: { url: string, width: number, height: number }) {
    return breakpoints.map((breakpoint) => ({
        src: `${url}&w=${breakpoint}`,
        width: breakpoint,
        height: Math.round((height / width) * breakpoint),
    }));
}*/

export default function Galerie({ galerie_id }) {
    const [index, setIndex] = useState(-1);
    const { loading, error, data } = useFetch(
        `https://steadfast-festival-dd089030c4.strapiapp.com/api/galleries/${galerie_id}?populate=*`,
        {
            headers: {
                Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
                "Content-Type": "application/json",
            },
        }
    );

    if (loading) return <p>Loading...</p>;
    if (error || !data?.data) return <p>Error loading gallery.</p>;

    console.log(data)

    const images = data.data.Fotos;

    let width ="";
    let height ="";
    let src ="";


    const photos = images.map((img) => {
        const width = img.width || 1200;
        const height = img.height || 800;

        return {
            src: img.url,
            width,
            height,

        };
    });

    return (
        <div>
            <Container fluid="md">
                <Row>
                    <Col>
                        <div style={{float: "left", marginBottom: 20, marginTop: 30}}>
                            <h1>{data.data.Title}</h1>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <>
                        <RowsPhotoAlbum photos={photos} targetRowHeight={150} onClick={({ index }) => setIndex(index)} />

                        <Lightbox
                            slides={photos}
                            open={index >= 0}
                            index={index}
                            close={() => setIndex(-1)}
                            plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
                        />
                    </>
                        </Col>
                </Row>
            </Container>
        </div>
    );
}
